export enum RoutePath {
    BACKOFFICE = 'backoffice',
    HOME = 'inicio',
    RATES = 'tasas',
    DETAIL = 'detalle',
    EDIT = 'editar',
    CREATE = 'crear',
    LOGIN = 'login',
    USERS = 'usuarios',
    PROFILES = 'perfiles',
    CONCILIATIONS = 'conciliaciones',
    CONFIGURATION_KYES = 'configuracion-llaves',
    FORGOT_PASSWORD = 'forgot-password',
    BULK_LOAD = 'cargas-masivas',
    LINKS = 'links',
    FRONT_TRACKER = 'front-tracker',
    PAYMENTS = 'pagos',
    LIQUIDACION = 'liquidacion',
    CANCELLATIONS = 'anulaciones',
    CANCELLATIONS_TOKEN = 'anulacion-token',
    CANCELLATIONS_REGISTRY = 'registro-anulaciones',
    POSITIVE_LIST = 'lista-positiva',
    RISK = 'riesgo',
    DOWNLOAD = 'descargar',
    UPLOAD = 'subir',
    CONFIGURATION_GLOSAS = 'glosas',
    CONFIGURATION = 'configuracion',
    CONFIGURATION_PAYMENTS = 'metodosdepago',
    CONFIGURATION_BINES_FLOWS = 'bines-flows',
    CONFIGURATION_AUTORIZADOR_FLUJOS = 'autorizador-flujos',
    CONFIGURATION_INSTALLMENTS = 'cuotas',
    ACQUIRING_RATES = 'tasas-adquirente',
    CONTINGENCY = 'procesador-contingencia',
    MERCHANTS = 'comercios',
    MERCHANT_STORES = 'tiendas',
    CUADRE = 'cuadre',
    CUADRE_DETALLE = 'detalle',
    CUADRE_EJECUTIVO = 'ejecutivo',
    CUADRE_PAGOS = 'pagos',
    REFUNDS = 'devoluciones',
    REFUNDS_INDIVIDUAL = 'registro-individual',
    REFUNDS_BULK = 'registro-masivo',
    REFUNDS_QUERY = 'consulta',
    RISK_RIESGOS = 'riesgos',
    RISK_SCORING = 'scoring',
    RISK_SCORING_CREATE = 'agregar',
    RISK_SCORING_EDIT = 'editar',
    RISK_SCORING_CATEGORIES = 'categorias',
    RISK_SCORING_TRANSACTIONS = 'transacciones',
    USERS_ADMIN = 'administrativo',
    USERS_EXECUTIVE = 'ejecutivo',
    QUERIES = 'consultas',
    QUERIES_AGW = 'agw-transacciones',
    QUERIES_COMERCIOS = 'comercios-qr',
    QUERIES_FINANCIERA = 'financiera-oh',
    MERCHANT_CONFIG = 'config-comercio',
}